import { combineReducers } from 'redux';
import commonReducer from './common';
import settingReducer from './setting';
import authorizationReducer from './authorization';
import selectReducer from './select';
import dockerImageReducer from './dockerImage';
import appInstanceReducer from './appInstance';
import containerAppReducer from './containerApp';
import idpClientReducer from './idpclient';
import webhookRegistrationReducer from './webhookRegistration';
import pipelineReducer from './pipelines';
import auditLogReducer from './auditLog';

import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

const authPersistConfig = {
  key: 'marketplace-developer-permissions',
  storage: storageSession,
  whitelist: ['permissions', 'loadedPermission'],
};

export const rootReducer = combineReducers({
  common: commonReducer,
  settings: settingReducer,
  authorization: persistReducer(authPersistConfig, authorizationReducer),
  select: selectReducer,
  dockerImage: dockerImageReducer,
  appInstance: appInstanceReducer,
  containerApp: containerAppReducer,
  idpClient: idpClientReducer,
  webhookRegistration: webhookRegistrationReducer,
  pipeline: pipelineReducer,
  auditLog: auditLogReducer,
});
